import { Modal } from "react-bootstrap";
import { GetPayLoad } from "../services/PayLoadStorage";

const ViewDetailsModal = ({ column, row, modal, setModal, pageType }) => {
    const Payload = GetPayLoad('PayLoad');
    const getModalTitle = () => {
        if (pageType === "policy") {
            return (
                <div className="nav nav-tabs" id="nav-tab" role="tablist">
                    <button className="nav-link active" id="nav-policy-tab" data-bs-toggle="tab" 
                            data-bs-target="#nav-policy" type="button" role="tab" 
                            aria-controls="nav-policy" aria-selected="true">
                        {modal}
                    </button>
                </div>
            );
        } else {
            return modal;
        }
    };
    const getHeaderClass = () => {
        const baseClass = pageType === "policy" ? "modal-header" : "modal-header pb-4 coverage-header";
        return `${baseClass} ${Payload?.owning_carrier === 'Q5' ? 'mobile-close-btn' : ''}`;
    };
    return (
        <Modal  size="md" show={modal} onHide={() => { setModal() }}>
            <Modal.Header className={getHeaderClass()} closeButton>
                <Modal.Title>{getModalTitle()}</Modal.Title>
            </Modal.Header>
            <Modal.Body >
                <div className="tab-content" id="nav-tabContent">
                    <div className="tab-panel fade show active" id="nav-home">
                        <div className="row mb-3">
                            {column?.name && <div tabIndex={0} className={`col-12 col-sm-6 ${column?.type ? 'col-md-3 col-xl-4' : 'col-md-4 col-xl-4'} labels mb-2 mb-md-0`}>
                                <label className="label-heading d-block">{column?.name}</label>
                                <label className="label-name fw-semibold d-block text-break">{row?.name_value}</label>
                            </div>}
                            {column?.type && <div tabIndex={0} className={`col-12 col-sm-6 col-md-3 col-xl-7 labels mb-2 mb-md-0`}>
                                <label className="label-heading d-block">{column?.type}</label>
                                <label className="label-name fw-semibold d-block text-break">{row?.type_value}</label>
                            </div>}
                            {column?.email && <div tabIndex={0} className={`col-12 ${column?.type ? 'col-sm-12 col-md-6 col-xl-7' : 'col-sm-6 col-md-8 col-xl-7'} labels mb-2 mb-md-0`}>
                                <label className="label-heading d-block">{column?.email}</label>
                                <label className="label-name fw-semibold d-block text-break">{row?.email_value}</label>
                            </div>}
                        </div>
                        <div className="row mb-3">
                            {column?.phone &&
                                <div tabIndex={0} className="col-12 col-sm-6 col-md-4 col-xl-4 labels mb-2 mb-md-0">
                                <label className="label-heading d-block">{column?.phone}</label>
                                <label className="label-name fw-semibold d-block text-break"> {row?.phone_value}</label>
                            </div>
                            }
                            {column?.address && <div tabIndex={0} className="col-12 col-sm-6 col-md-8 col-xl-7 labels mb-2 mb-md-0">
                                <label className="label-heading d-block">{column?.address}</label>
                                <label className="label-name fw-semibold d-block text-break">
                                    {row?.address_value}
                                </label>
                            </div>}
                        </div>
                        <div className="row mb-3">
                            {column?.secondary_phone &&
                            <div tabIndex={0} className="col-12 col-sm-6 col-md-4 col-xl-4 labels mb-2 mb-md-0">
                                <label className="label-heading d-block">{column?.secondary_phone}</label>
                                <label className="label-name fw-semibold d-block text-break">{row?.secondary_phone_value}</label>
                            </div>
                            }
                        </div>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default ViewDetailsModal;